import React, { useState } from 'react';
import Menu from '@material-ui/core/Menu';
import { trans } from '../../../../_providers/Translation';

//images
import menuIcon from '../../../../assets/img/icons/table-menu.png';
import editIcon from '../../../../assets/img/icons/edit.png';
import deleteIcon from '../../../../assets/img/icons/delete.png';

function Index(props) {

    const [table, setTable] = useState({
        options: null
    });

    const handleTableMenu = e => {

        setTable(table => {
            return {
                ...table,
                options: e.currentTarget
            }
        });
    };

    const handleCloseMenu = () => {
        setTable(table => {
            return {
                ...table,
                options: null
            }
        });
    };

    const handleMarkAsPaid = id => {
        handleCloseMenu();

        props.handleMarkAsPaid(id);
    }

    const handleMakeInvoice = id => {
        handleCloseMenu();

        props.handleMakeInvoice(id);
    }

    const handleDelete = id => {
        handleCloseMenu();

        props.handleDelete(id);
    }

    return (
        <>
            <img src={menuIcon} alt="menu" className="menu" onClick={handleTableMenu} />
            <Menu
                id={'menu-' + props.id}
                anchorEl={table.options}
                keepMounted
                open={Boolean(table.options)}
                onClose={handleCloseMenu}
            >

                {!props.data.paid
                    ?
                    <div className="menu-option" onClick={() => handleMarkAsPaid(props.id)}>
                        <img src={editIcon} alt="edit" />
                        {trans('buttons.markAsPaid')}
                    </div>
                    :
                    ''
                }
                {!props.data.paid
                    ?
                    <div className="menu-option" onClick={() => handleDelete(props.id)}>
                        <img src={deleteIcon} alt="edit" />
                        {trans('buttons.delete')}
                    </div>
                    :
                    ''
                }
                {props.data.paid && !props.data.invoiced
                    ?
                    <div className="menu-option" onClick={() => handleMakeInvoice(props.id)}>
                        <img src={editIcon} alt="edit" />
                        {trans('buttons.createInvoice')}
                    </div>
                    :
                    ''
                }

            </Menu>
        </>
    )
}

export default Index;
